import { render, staticRenderFns } from "./AdiPropostaDiAccessoComponent.vue?vue&type=template&id=7a98d792"
import script from "./AdiPropostaDiAccessoComponent.vue?vue&type=script&lang=js"
export * from "./AdiPropostaDiAccessoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports